<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ title }}</h5>
                        <button class="btn" @click="$emit('cancel')">
                            <b-icon icon="x"></b-icon>
                        </button>
                    </div>

                    <div class="modal-body">
                        <ActionModal
                            v-if="loading"
                            :text="$t('loading-form')"
                            :modalStyle="{ height: 'auto' }"
                            class="mb-1"
                        />
                        <ActionModal
                            v-else-if="error"
                            :title="$t('error')"
                            :text="$t('could-not-load-form')"
                            :modalStyle="{ height: 'auto' }"
                            iconType="exclamation-triangle-fill"
                            iconVariant="danger"
                            class="mb-1"
                        />
                        <template v-else-if="formresponse">
                            <template v-for="(page, pageIndex) in pages">
                                <div :key="pageIndex" v-if="pageNum == pageIndex + 1">
                                    <h3 v-if="page.title">{{ page.title }}</h3>
                                    <FormGrid
                                        :page="page"
                                        :formresponse="formresponse"
                                        viewAs="submitter"
                                    />
                                </div>
                            </template>
                        </template>
                    </div>

                    <div class="modal-footer" v-if="formresponse && !loading && !error">
                        <button
                            class="btn btn-secondary"
                            v-if="showPreviousPageBtn"
                            @click="pageNum--"
                        >
                            {{ $t('previous-page') }}
                        </button>
                        <button
                            type="button"
                            class="btn btn-secondary mr-auto"
                            @click="$emit('cancel')"
                        >
                            {{ $t('cancel') }}
                        </button>
                        <button
                            class="btn btn-primary"
                            v-if="showNextPageBtn"
                            @click="pageNum++"
                        >
                            {{ $t('next-page') }}
                        </button>
                        <button
                            v-else
                            type="button"
                            class="btn btn-primary"
                            :disabled="submitting"
                            @click="submit"
                        >
                            {{ $t('submit') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ActionModal from 'src/components/ActionModal.vue';
import FormGrid from 'src/components/FormEditor/FormGrid';

export default {
    components: { ActionModal, FormGrid },
    props: {
        formId: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            formresponse: null,
            loading: false,
            error: false,
            pageNum: 1,
            submitting: false
        };
    },
    computed: {
        pages() {
            if (!this.formresponse || !this.formresponse.formresponse_data) return [];
            return this.formresponse.formresponse_data.pages || [];
        },
        title() {
            return (this.formresponse && this.formresponse.formresponse_data && this.formresponse.formresponse_data.title)
                ? this.formresponse.formresponse_data.title
                : '';
        },
        showNextPageBtn() {
            return this.formresponse
                && this.formresponse.formresponse_data
                && this.formresponse.formresponse_data.next
                && this.pageNum < this.pages.length;
        },
        showPreviousPageBtn() {
            return this.formresponse
                && this.formresponse.formresponse_data
                && this.formresponse.formresponse_data.previous
                && this.pageNum > 1;
        }
    },
    mounted() {
        this.loadForm();
    },
    methods: {
        loadForm() {
            this.loading = true;
            this.error = false;
            this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/getform/${this.formId}`)
                .then(json => {
                    if (json.status === 'SUCCESS') {
                        this.formresponse = {
                            id: null,
                            form_id: json.form.id,
                            user_id: this.$UserSession.getValue('id'),
                            userfrom_id: null,
                            usersubject_id: null,
                            userreview_id: null,
                            usersignofffrom_id: null,
                            externaluser_id: null,
                            datetime: this.$datetime.getDateTimeLocalFieldNowValue(),
                            workbooks: [],
                            workflowstage: {},
                            formresponse_data: json.form.settings
                        };
                    } else {
                        this.error = true;
                    }
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        submit() {
            this.submitting = true;
            this.$store.commit('showBlockingSpinner');
            this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/save/`, {
                method: 'post',
                data: { formresponse: this.formresponse }
            })
                .then(json => {
                    if (json.status.toLowerCase() === 'success') {
                        this.$emit('submitted', json);
                    } else {
                        this.$store.commit('openDialog', {
                            title: this.$t('oops'),
                            content: this.$t('something-went-wrong')
                        });
                    }
                })
                .catch(() => {
                    this.$store.commit('openDialog', {
                        title: this.$t('oops'),
                        content: this.$t('something-went-wrong')
                    });
                })
                .finally(() => {
                    this.$store.commit('hideBlockingSpinner');
                    this.submitting = false;
                });
        }
    }
};
</script>

<style scoped>
::v-deep .btn-group {
    display: block !important;
}
</style>
